// コンパス (DeviceOrientation API)
// 端末の向きを取得して方位(度)を返す
//
// iOS Safari は許可ダイアログが必要(13.4+)

let listener = null;
let lastHeading = null;
let listeners = new Set();

function handleOrientation(e) {
  // iOS は webkitCompassHeading が真北からの絶対方位、Android は alpha
  let heading = null;
  if (typeof e.webkitCompassHeading === 'number') {
    heading = e.webkitCompassHeading;
  } else if (typeof e.alpha === 'number') {
    heading = 360 - e.alpha; // alpha は反時計回り、heading は時計回り
  }
  if (heading === null) return;
  lastHeading = heading;
  listeners.forEach((fn) => {
    try { fn(heading); } catch (_) { /* noop */ }
  });
}

export async function startCompass() {
  if (listener) return true;
  // iOS 13.4+ で許可リクエストが必要
  if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
    try {
      const res = await DeviceOrientationEvent.requestPermission();
      if (res !== 'granted') return false;
    } catch (e) {
      return false;
    }
  }
  // iOS は orientationabsolute / orientation でなく deviceorientation
  window.addEventListener('deviceorientation', handleOrientation, true);
  listener = handleOrientation;
  return true;
}

export function stopCompass() {
  if (listener) {
    window.removeEventListener('deviceorientation', listener, true);
    listener = null;
  }
}

export function subscribeCompass(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getCurrentHeading() {
  return lastHeading;
}

// 方位角を日本語表記に
export function headingToCardinal(h) {
  if (typeof h !== 'number') return '—';
  const dirs = ['北', '北北東', '北東', '東北東', '東', '東南東', '南東', '南南東', '南', '南南西', '南西', '西南西', '西', '西北西', '北西', '北北西'];
  const idx = Math.round(h / 22.5) % 16;
  return dirs[idx];
}
